import Utils from './utils.js';

const CONTACT_ADDRESS = 'eli@wuju.app';

var Email = {
  init() {},

  openContactDialog($f7, title, text) {
    $f7.dialog.create({
      title: title || `How can I help?`,
      content:
        (text ? `<p style="font-size: 90%; padding-bottom: 10px; border-bottom: 1px #eee solid; color: black;">${text}</p>` : `<br>`) + `
          <textarea placeholder="type your message here..." style="margin-top: 10px; min-height: 100px; max-height:200px; width: 100%;" class="dialog-message resizable"></textarea>
          <img style="width: 30px; border-radius: 5px; position: absolute; top: 10px; right: 10px;" src="/static/img/eli.jpg">
          <p style="font-size: 80%; color: #999; margin-top: 10px;">Send opens your email app with the message pre-filled.</p>
        `,
      buttons: [
        { text: 'Cancel', color: 'theme', keyCodes: [27] },
        { text: 'Send', color: 'theme', bold: true, close: false },
      ],
      onClick(dialog, index) {
        if (index !== 1) return;
        const message = dialog.$el.find('.dialog-message').val();
        if (!message) return;
        const subject = `wuju: ${Utils.shorten(message, 5)}`;
        window.location.href = `mailto:${CONTACT_ADDRESS}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(message)}`;
        dialog.close();
      },
      destroyOnClose: true,
    }).open();
  },
};

export default Email;
